import { FC, memo, PropsWithChildren } from "react";

export type RootProps = {
  requiredAuth?: boolean;
};

const Root: FC<PropsWithChildren<RootProps>> = ({ children }) => {
  return <>{children}</>;
};

export default memo(Root);
